import request from "@/utils/request";
import { apiConfig } from "../config/api";


// 下载量表试卷
export function downloadScaleSubject(req) {
  return request({
    url: apiConfig.scaleInfo.api.downloadScaleSubject.url,
    method: "post",
    data: req,
    responseType: "blob"
  });
}
// 量表分页列表
export function getScalePager(req, pager) {
  return request({
    url: apiConfig.scaleInfo.api.pager.url,
    method: "post",
    data: {
      scaleName: req.scaleName,
      startDate: req.startDate,
      endDate: req.endDate,
      page: pager.page,
      pageSize: pager.pageSize
    }
  });
}
// 量表分页列表搜索功能
export function searchScalePager(req, pager) {
  return request({
    url: apiConfig.scaleInfo.api.searchPager.url,
    method: "post",
    data: {
      scaleName: req.scaleName,
      startDate: req.startDate,
      endDate: req.endDate,
      page: pager.page,
      pageSize: pager.pageSize
    }
  });
}
// 量表分页列表搜索功能
export function getScaleProjectList(req) {
  return request({
    url: apiConfig.scaleInfo.api.getProjectList.url,
    method: "get",
    params: {
      scaleId: req.scaleId
    }
  });
}
// 查看量表基本信息
export function findScale(scaleId) {
  return request({
    url: apiConfig.scaleInfo.api.find.url,
    method: "get",
    params: {
      scaleId: scaleId
    }
  });
}
// 编辑量表
export function editScale(req) {
  return request({
    url: apiConfig.scaleInfo.api.edit.url,
    method: "post",
    data: {
      realName: req.realName,
      idNumber: req.idNumber,
      registerFrom: req.registerFrom,
      baseInfoAuditStatus: req.baseInfoAuditStatus,
      startDate: req.startDate,
      endDate: req.endDate
    }
  });
}
// 删除量表
export function deleteScale(req) {
  return request({
    url: apiConfig.scaleInfo.api.delete.url,
    method: "post",
    data: {
      id: req.scaleId,
      isDel: 0
    }
  });
}
// 导出量表
export function exportScale(req) {
  return request({
    url: apiConfig.scaleInfo.api.export.url,
    method: "post",
    data: {
      realName: req.realName,
      idNumber: req.idNumber,
      registerFrom: req.registerFrom,
      baseInfoAuditStatus: req.baseInfoAuditStatus,
      startDate: req.startDate,
      endDate: req.endDate
    }
  });
}
// 批量导出量表
export function exportScaleBatch(req) {
  return request({
    url: apiConfig.scaleInfo.api.exportBatch.url,
    method: "post",
    data: {
      realName: req.realName,
      idNumber: req.idNumber,
      registerFrom: req.registerFrom,
      baseInfoAuditStatus: req.baseInfoAuditStatus,
      startDate: req.startDate,
      endDate: req.endDate
    }
  });
}
// 根据量表名称模糊查询量表列表
export function getScaleByName(scaleName) {
  return request({
    url: apiConfig.scaleInfo.api.getScaleByName.url,
    method: "get",
    params: {
      scaleName: scaleName
    }
  });
}

// 量表列表
export function getScaleList() {
  return request({
    url: apiConfig.scaleInfo.api.scaleList.url,
    method: "get"
  });
}

export function exportScaleRanking(req) {
  return request({
    url: apiConfig.examScaleApi.api.exportScaleRanking.url,
    method: "post",
    data: req,
    responseType: "blob"
  });
}
